import { Messages } from '../../../../codegen/Localize';

import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { groupDatabasesAction, DatabaseForGrouping } from '../../../actions/spaces/GroupDatabasesAction';
import { CompositeSessionInfoSelectors } from '../../../selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const GroupDatabasesAction: IEntityAction<DatabaseForGrouping, {}> = {
  name: EntityActionNames.GroupDatabases,
  translateName: Messages.groupDatabases_action,
  isVisible: (items: DatabaseForGrouping[], state) => {
    const featureEnabled =
        CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state) &&
        FeatureFlags.mergeDedupeDatabasesEnabled &&
        selectCatalogingOnSiteEnabled(state);
    const hasUngroupedItems = items.some(item => !item.isGrouped);
    return featureEnabled && hasUngroupedItems;
  },
  isClickable: (_, items) => {
    const hasOnlyUngroupedItems = items.every(item => !item.isGrouped);
    const connectionTypesMatch = items.every(item => item.connectionType === items[0].connectionType);
    return items.length > 1 && hasOnlyUngroupedItems && connectionTypesMatch;
  },
  createReduxAction: (items: DatabaseForGrouping[]) => {
    return groupDatabasesAction(items);
  }
};
